import type { SliderProps } from '@radix-ui/react-slider';
import { Range, Root, Thumb,Track } from '@radix-ui/react-slider';
import cn from 'classnames';
import { FCP } from 'types';

import classes from './index.module.css';

interface Props extends Omit<SliderProps, 'onValueChange'>, FCP {
  onValueChange(value: number): void;
};

const Slider = ({ value = [0], min = 0, max = 100, step = 1, className, onValueChange }: Props) => {
  const onChange: SliderProps['onValueChange'] = (value) => onValueChange(value?.[0]);

  return (
    <Root
      className={cn(classes.root, className)}
      value={value}
      min={min}
      max={max}
      step={step}
      orientation="horizontal"
      onValueChange={onChange}
    >
      <Track className={classes.track}>
        <Range className={classes.range} />
      </Track>
      <Thumb className={classes.thumb} />
    </Root>
  );
};

export default Slider;
